export const BRAND_NAME = "BonusX";
export const BRAND_APP_IOS_DESCRIPTION = "I bonus in tasca";
export const BRAND_APP_ANDROID_DESCRIPTION = "Agevolazioni in tasca";
export const GOOD_TAGS = ["Lo vorrei in futuro", "Veloce", "Professionale", "Rassicurante"];
export const BAD_TAGS = ["Non lo vorrei in futuro", "Lento", "Non professionale", "Scortese"];
export const GOOD_BAD_TAGS: Array<[string, string]> = GOOD_TAGS.map(function pairChoices(value, index) {
  return [value, BAD_TAGS[index]];
});
export const DEFAULT_CURRENCY = "EUR";

export const FULFILL_INFO_TEXT = "Completa le informazioni";
export const FULFILL_INFO_CHIP_TEXT = "Completa informazioni";

export const UPDATE_PROFILE_TEXT = "Aggiorna il profilo";
export const UPDATE_PROFILE_CHIP_TEXT = "Non richiedibile";
export const PROCESSING_REQUEST_CHIP_TEXT = "Pratica in elaborazione";

export const CONFIRM_REQUISITES_TEXT = "Conferma requisiti";
export const FALLBACK_TEXT = "Richiedi";

export const NEED_TO_UPDATE_PROFILE_MESSAGE =
  "Ops, al momento sembra che tu non abbia i requisiti necessari. Aggiorna il profilo per capire se ne hai diritto.";
export const NEED_TO_COMPLETE_SECTION_TEXT =
  "Per procedere con la richiesta, devi prima completare i dati nel profilo fino a";

export const NEED_TO_COMPLETE_BY_ENTITIES_SECTION_TEXT =
  "Per procedere con la richiesta, devi prima completare le sezioni nel profilo";

export const NEED_TO_COMPLETE_PROFILE_TEXT =
  "Per scoprire se ne hai diritto devi prima completare i dati nel profilo fino a";
export const INFO_BONUS_COMPLETE_PROFILE_TEXT = "Per scoprire se questo bonus ti spetta, completa alcune informazioni";
export const YOU_COULD_HAVE_ACCESS_TO_THIS_PRODUCT_TEXT =
  "In base ai dati inseriti nel tuo profilo, potresti averne diritto. Leggi sotto per conoscere i requisiti e come richiederlo";
export const PRODUCT_NOT_REQUESTABLE_ADVICE_BOX =
  "Anche se lo status è {status}, non è comunque richiedibile in questo periodo dell’anno. Leggi sotto per conoscere le tempistiche di richiesta";
export const NEED_TO_COMPLETE_REQUISITES =
  "Ci sei quasi! Rispondi ad alcune domande per confermare il possesso dei requisiti.";
export const FILTERS_TEXT = "Filtri";
export const FILTERS_MOBILE_TEXT = "Scegli cosa ti interessa";
export const SHOW_FILTERS_TEXT = "Mostra filtri";
export const HIDE_FILTERS_TEXT = "Chiudi filtri";
export const RESET_FILTERS_TEXT = "Reset filtri";
export const APPLY_FILTERS_TEXT = "Applica filtri";
export const INSERT_YOUR_EMAIL_TEXT = "Inserisci la tua email";
export const MODIFY_FAMILY_MEMBERS_TEXT = "Modifica nucleo";
export const BACK_TO_PROFILE_TEXT = "Torna al profilo";
export const NAME_TYPO = "Nome";
export const SURNAME_TYPO = "Cognome";
export const TAX_CODE_TYPO = "Codice Fiscale";
export const COMPLETE_PROFILE_ERROR_TYPO = "L'hai scritto bene? Riprova.";
export const PASSWORD_TEXT = "Password";
export const NAME_TEXT = "Nome";
export const SURNAME_TEXT = "Cognome";
export const TAX_CODE_TEXT = "Codice Fiscale";
export const TAX_CODE_CAPITALIZED_TEXT = "Codice fiscale";
export const BIRTH_DATE_TEXT = "Data di nascita";
export const COMPLETE_PROFILE_ERROR_TEXT = "L'hai scritto bene? Riprova.";
export const FISCAL_CODE_FROM_AGE_TEXT =
  "Il codice fiscale inserito è di un minorenne. Per usare BonusX, bisogna essere maggiorenni.";
export const HAPPY_TO_SEE_YOU_TEXT = "Siamo felici di rivederti!";
export const CHECK_SPAM_EMAIL_SENT =
  "Se non trovi l’email con il cambio password, controlla nello SPAM oppure inserisci un indirizzo nuovo";
export const NEXT_TEXT = "Avanti";
export const PRIVACY_POLICY_USER_TEXT = "Acconsento al trattamento dati*";
export const PRIVACY_POLICY_DESCRIPTION_TEXT =
  "Bisogna accettare il trattamento dati per poter procedere alla registrazione";
export const CHANGE_EMAIL_TEXT = "Cambia email";
export const EMAIL_NOT_RECEIVED_TEXT = "L’email non ti è arrivata?";
export const API_GENERAL_ERROR_TEXT = "Qualcosa è andato storto";
export const SUGGEST_NEW_BONUSES_TEXT =
  "Non ci sono bonus per te interessanti? Suggeriscili! Puoi anche indicare categorie o aree geografiche.";
export const NO_REQUISITES_ESCLAMATION_TEXT = "Ahia";
export const REQUISITES_NOT_MET_DESCRIPTION_TEXT =
  "Sulla base delle informazioni che ci hai dato, sembra che al momento tu non possa fare richiesta. Tieni aggiornati i tuoi dati, potresti riprovare più avanti.";
export const SEE_ALL_BONUSES_TEXT = "Vedi tutti i bonus";
export const REQUISITES_MET_ESCLAMATION_TEXT = "Fantastico!";
export const REQUISITES_MET_DESCRIPTION_TEXT = "Sembra che tu possa fare richiesta, procedi pure.";
export const REQUISITES_TIER_PLACEHOLDER = "{{TIER}}";
export const REQUISITES_MET_FLEXIBLE_STRUCTURE_DESCRIPTION_TEXT = `Sembra che tu possa fare richiesta, fai l’upgrade a ${REQUISITES_TIER_PLACEHOLDER} per procedere.`;
export const NO_AVAILABLE_TIER_TEXT = "Non richiedibile in questo momento";
export const NOT_NOW_TEXT = "Non ora";
export const COPY_LINK_TEXT = "Copia link";
export const LINK_COPIED_TEXT = "Link copiato";
export const SHOW_INVITE_FRIENDS_TEXT = "Tieni d'occhio gli inviti";
export const INVITE_IN_BONUSX = "Invita su BonusX";
export const UPGRADE_TEXT = "Upgrade";
export const SHARE_LINK_TEXT = "Condividilo qui, fai prima:";
export const CHIP_MANDATORY_TEXT = "Obbligatorio";
export const MAX_FILE_SIZE_TEXT = "Massimo 18Mb.";
export const USE_THE_APP = "Usa l'app";
export const EMPTY_STRING = "";
export const DEFAULT_BACK_TO_LABEL = "Torna indietro";
export const CHAT_WITH_OPERATOR_CLOSED_BECAUSE_OF_TIME_TEXT = `La chat è chiusa perché sono trascorsi più di due mesi dalla finalizzazione della pratica.`;
export const CHAT_WITH_OPERATOR_NEED_TO_SEND_PRACTICE_TEXT = `Potrai scrivere all'operatore dopo aver inviato la pratica.`;
export const SEARCH_PLACEHOLDER = "Che bonus o servizio cerchi?";
export const GREET_TEXT = "Ciao";
export const ADD_YOUR_PHONE_NUMBER_TEXT = "Inserisci il tuo numero di cellulare";
export const PHONE_NUMBER_REQUIREMENT_TEXT =
  "il tuo numero di cellulare è necessario per la gestione delle pratiche. Puoi sempre modificarlo nelle impostazioni.";
export const CONFIRM_PHONE_NUMBER_TEXT = "Conferma numero";
export const GENERIC_ERROR_TEXT = "Si è verificato un errore. Riprova più tardi";

// Notifications section
export const NOTIFICATIONS_PAGE_TITLE = "Notifiche";
export const MARK_ALL_AS_READ_TEXT = "Segna tutte come lette";
export const MARK_AS_READ_TEXT = "Segna come letta";
export const MARK_AS_TO_READ_TEXT = "Segna come non letta";
export const NOTICATIONS_SET_MARKED_AS_READ = "Notifiche segnate come lette";
export const NOTICATION_MARKED_AS_READ = "Notifica segnata come letta";
export const NOTICATION_MARKED_AS_NOT_READ = "Notifica segnata come non letta";
export const NO_NEW_NOTIFICATIONS = "Non hai nuove notifiche";
export const NO_NEW_NOTIFICATIONS_DESCRIPTION =
  "Non hai notifiche. Vi faremo sapere quando arriveranno gli aggiornamenti!";
export const UNDO_TEXT = "Annulla";

export const MANAGE_YOUR_PLAN_TEXT = "Gestisci il tuo abbonamento";

export const GET_PRICING_PAGE_ERROR_TEXT =
  "Si è verificato un errore durante il recupero delle informazioni. Riprova più tardi.";

// Pricing page
export const PRICING_PAGE_SEO_TITLE = "Scegli il piano adatto a te";
export const PRICING_PAGE_TITLE = "Upgrade";
export const PRICING_PAGE_YOUR_CURRENT_PLAN_LABEL = "il tuo piano attuale";

export const EXTERNAL_PLAN_SELECTION_QUERY_PARAM_NAME = "plan";
export const PRODUCT_ID_QUERY_PARAM_NAME = "productId";

export const SETTINGS_PAGE_TITLE = "Impostazioni";

export const MANAGE_SUBSCRIPTION_PAGE_TITLE = "Il tuo piano";
export const ANNUAL_PLAN_TEXT = "Piano annuale";

export const UNAVAILABLE_TEXT = "Non disponibile";
